import produce from "immer";
import { createAction } from "redux-smart-actions";
import { createSelector } from "reselect";
import { KomutRedux } from "../base/types/KomutRedux";
import { RootState } from "../base/types/RootState";
import { GarageCartItem } from "./type";

const ADD_TO_GARAGE = "ADD_TO_GARAGE";
const UPDATE_TO_GARAGEITEM = "UPDATE_TO_GARAGEITEM";
const REMOVE_TO_GARAGE = "REMOVE_TO_GARAGE";
const CLEAR_GARAGE = "CLEAR_GARAGE";

const ADD_LIST_TO_GARAGE = "ADD_LIST_TO_GARAGE";
export interface GarageCartReducer {
  garageCartItems: GarageCartItem[];
}

export interface GarageCartActions {
  addToGarage: any;
  removeToGarage: any;
  updateGarageItem: any;
  clearGarage: any;
  addListToGarage: any;
}

const garageCart = new KomutRedux<GarageCartReducer, GarageCartActions>();

garageCart.setInitialState({
  garageCartItems: [],
});

garageCart.setActions({
  addToGarage: createAction(ADD_TO_GARAGE, (payload: GarageCartItem) => ({
    payload,
  })),
  removeToGarage: createAction(REMOVE_TO_GARAGE, (payload: GarageCartItem) => ({
    payload,
  })),
  updateGarageItem: createAction(
    UPDATE_TO_GARAGEITEM,
    (payload: GarageCartItem) => ({
      payload,
    })
  ),
  clearGarage: createAction(CLEAR_GARAGE),
  addListToGarage: createAction(
    ADD_LIST_TO_GARAGE,
    (payload: GarageCartItem[]) => ({
      payload,
    })
  ),
});

garageCart.setRedusers(
  produce((draft: GarageCartReducer, { type, payload }) => {
    switch (type) {
      case ADD_TO_GARAGE:
        draft.garageCartItems = [...draft.garageCartItems, payload];
        break;
      case ADD_LIST_TO_GARAGE:
        draft.garageCartItems = [...payload];
        break;
      case REMOVE_TO_GARAGE:
        draft.garageCartItems = draft.garageCartItems.filter(
          (x) => x.Id !== payload.Id
        );
        break;
      case CLEAR_GARAGE:
        draft.garageCartItems = [];
        break;
      case UPDATE_TO_GARAGEITEM: {
        const existingItemIndex = draft.garageCartItems.findIndex(
          (x) => x.Id === payload.Id
        );
        if (existingItemIndex >= 0) {
          draft.garageCartItems[existingItemIndex].ExtraServices =
            payload.ExtraServices;
          draft.garageCartItems[existingItemIndex] = payload;
        }
      }
    }
  }, garageCart.initialState)
);

// ** SELECTORS *** \\
const garageCartState = (state: RootState) => state.garage.garageCartItems;
export const garageCartSelector = createSelector(
  [garageCartState],
  (state) => state
);

export default garageCart;
